import { render, staticRenderFns } from "./AssetCompressionData.vue?vue&type=template&id=c3537522&lang=pug"
import script from "./AssetCompressionData.vue?vue&type=script&lang=js"
export * from "./AssetCompressionData.vue?vue&type=script&lang=js"
import style0 from "./AssetCompressionData.vue?vue&type=style&index=0&id=c3537522&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports